import React from 'react';

import refreshImg from 'img/refresh.svg';
import { Button } from 'components/Button';

const IndicatorRefreshButton: React.FC<{
  icon?: string;
  html?: boolean;
  refreshSize: string;
  onReload: () => void;
  tooltip?: string;
}> = (props) => {

  const { onReload, refreshSize, tooltip, icon, html } = props;

  return (
    <Button onClick={() => onReload()} tooltip={tooltip ?? ""} html={html ?? false}>
      <>
        <img
          className="animated rotateIn"
          src={icon ?? refreshImg}
          alt="reload-indicator"
          style={{ height: refreshSize, width: refreshSize }}
        />
      </>
    </Button>
  );
};

export default IndicatorRefreshButton;
